import styled from 'styled-components'

export const TextBox = styled.p`
  background: #F5F5F5;
  border-radius: 0px 16px 16px 0px;
  width: 100%;
  max-width: 234px;
  font-style: normal;
  font-size: 16px;
  line-height: 150%;
  padding: 8px 8px 8px 16px;
  margin: 8px 0;
`